(function () {
  function initCarousel(root) {
    if (root.dataset.mkDragInit === '1') return;
    root.dataset.mkDragInit = '1';

    var track = root.querySelector('.mk-drag-carousel__track');
    if (!track) return;

    var direction = root.dataset.direction === 'right' ? 1 : -1;
    var duration = parseFloat(root.dataset.speed) || 30;

    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;

    var setWidth = track.scrollWidth;
    var target = root.clientWidth * 2 + setWidth;
    var guard = 0;
    while (track.scrollWidth < target && guard < 20 && setWidth > 0) {
      for (var i = 0; i < originals.length; i++) {
        var clone = originals[i].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }
      guard++;
    }

    var pxPerSec = duration > 0 ? setWidth / duration : 0;
    var offset = 0;
    var last = null;
    var dragging = false;
    var pointerId = null;
    var startX = 0;
    var startOffset = 0;
    var moved = false;
    var hovering = false;
    var visible = true;

    function wrap() {
      if (setWidth <= 0) return;
      while (offset <= -setWidth) offset += setWidth;
      while (offset > 0) offset -= setWidth;
    }

    function render() {
      track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
    }

    function frame(t) {
      if (last === null) last = t;
      var dt = (t - last) / 1000;
      last = t;
      if (dt > 0.1) dt = 0.1;
      if (!dragging && !hovering && visible) {
        offset += direction * pxPerSec * dt;
        wrap();
        render();
      }
      requestAnimationFrame(frame);
    }

    root.addEventListener('pointerenter', function () { hovering = true; });
    root.addEventListener('pointerleave', function () { if (!dragging) hovering = false; });

    track.addEventListener('pointerdown', function (e) {
      dragging = true;
      moved = false;
      pointerId = e.pointerId;
      startX = e.clientX;
      startOffset = offset;
      root.classList.add('is-dragging');
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 3) {
        moved = true;
        // Capture foerst NAAR der reelt traekkes: capture ved pointerdown fik
        // click-eventet dispatch'et til tracket i stedet for linket, saa
        // stillestaaende klik paa items aldrig navigerede.
        if (track.setPointerCapture) {
          try { track.setPointerCapture(pointerId); } catch (err) {}
        }
      }
      if (!moved) return;
      offset = startOffset + dx;
      wrap();
      render();
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-dragging');
      if (pointerId !== null && track.releasePointerCapture) {
        try { track.releasePointerCapture(pointerId); } catch (err) {}
      }
      pointerId = null;
      if (moved) {
        var suppress = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          track.removeEventListener('click', suppress, true);
        };
        track.addEventListener('click', suppress, true);
        setTimeout(function () { track.removeEventListener('click', suppress, true); }, 50);
      }
      hovering = false;
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { visible = en.isIntersecting; });
      }).observe(root);
    }

    requestAnimationFrame(frame);
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    container.querySelectorAll('[data-mk-drag-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
